import { render, staticRenderFns } from "./c-manage-pharmacists-list.vue?vue&type=template&id=97566f14&scoped=true&"
import script from "./c-manage-pharmacists-list.vue?vue&type=script&lang=js&"
export * from "./c-manage-pharmacists-list.vue?vue&type=script&lang=js&"
import style0 from "./c-manage-pharmacists-list.vue?vue&type=style&index=0&id=97566f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97566f14",
  null
  
)

export default component.exports